import React from 'react'
import { Badge } from '@/components/ui/badge'

class EnquiryLabelsPartial extends React.Component {

  render() {
    const label = this.props.label
    const size = this.props.size || 'default'

    if (label.type == 'warning') {
      return (
        <Badge variant="warning" size={size}>{this.props.label.name}</Badge>
      )
    }
    else if (label.type == 'success') {
      return (
        <Badge variant="success" size={size}>{this.props.label.name}</Badge>
      )
    }
    else {
      return (
        <Badge variant="secondary" size={size}>{this.props.label.name}</Badge>
      )
    }
  }
}

export default EnquiryLabelsPartial
